module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/label-1st@3x-1426be0d3ae445a4795b5a2c34902419.png";